<script setup>
import ProductsGrid from "@/components/molecules/ProductsGrid.vue";
import ProductsCarousel from "~/components/organisms/ProductsCarousel.vue";
import Heading from "~/components/atoms/Heading.vue";
import {PRODUCT_VIEW_BLOCKS} from '~/utils/productViewContext.js';

const props = defineProps({
  data: Object,
})

const {products} = toRefs(props.data)
</script>

<template>
  <div class="g-24 full-width">
    <Heading v-if="props.data.title" class="mini-grid-title" tag="h2">{{ props.data.title }}</Heading>
    <ProductsCarousel v-if="props.data.type === 'carousel'" :block="PRODUCT_VIEW_BLOCKS.miniProductsGrid" :products="products.map(product => ({
  ...product,
  bold_name: product.display_name,
  images: {
    image: product.image,
    second_image: product.second_image
  },
  prices: {
    standard: product.main_price ?? product.hc_standard_price,
    recommended: product.hc_recommended_price,
    discount: product.discount
  },
  }))"/>
    <ProductsGrid v-else :no-header="true" :block="PRODUCT_VIEW_BLOCKS.miniProductsGrid" :products="products"/>
  </div>
</template>

<style scoped lang="scss">
.mini-grid-title {
  @include smd {
    font-size: 22px;
  }
}
</style>
